module.exports = __webpack_public_path__ + "img/nahash_no.7ce2cf6d.png";